import { EUnitType } from '../enums/unit.enum'

export const mapUnitLabel = {
  [EUnitType.MS2]: 'м/с²',
  [EUnitType.G]: 'g',
  [EUnitType.MMS2]: 'мм/с²',
  [EUnitType.MMS]: 'мм/с',
  [EUnitType.MS]: 'м/с',
  [EUnitType.MKM]: 'мкм',
  [EUnitType.MM]: 'мм',
  [EUnitType.M]: 'м',
  [EUnitType.A]: 'А',
  [EUnitType.MA]: 'мА',
  [EUnitType.MKA]: 'мкА',
  [EUnitType.VOLT]: 'В',
  [EUnitType.M_VOLT]: 'мВ',
  [EUnitType.U_VOLT]: 'мкВ',
  [EUnitType.DEGREES]: '°C',
  [EUnitType.SECONDS_PER_ROTATION]: 'сек/об',
  [EUnitType.DEGREES_CELSIUS]: '°C',
  [EUnitType.DEGREES_FAHRENHEIT]: '°F',
  [EUnitType.DEGREES_KELVIN]: '°K',
  [EUnitType.HZ]: 'Гц',
  [EUnitType.ROTATION_COUNT_IN_MINUTE]: 'об/мин',
  [EUnitType.D_HZ]: 'ΔГц',
  [EUnitType.D_ROTATION_COUNT_IN_MINUTE]: 'Δоб/мин'
}

export const mapBaseVibrationUnits: { [key in string]: EUnitType } = {
  [EUnitType.MS2]: EUnitType.MS2,
  [EUnitType.G]: EUnitType.MS2,
  [EUnitType.MMS2]: EUnitType.MS2,
  [EUnitType.MMS]: EUnitType.MMS,
  [EUnitType.MS]: EUnitType.MMS,
  [EUnitType.MKM]: EUnitType.MKM,
  [EUnitType.MM]: EUnitType.MKM,
  [EUnitType.M]: EUnitType.MKM
}
